import React, { useState, useEffect } from "react";
import IColumn from "./types/column";
import styles from "./styles.module.scss";
import { Spacing } from "spacing/component";
import moment from "moment";
import "moment/locale/hr";
import { BodyFont, PageTitleFont } from "./../fonts";
import nextSrc from "../../assets/svgs/navigate_next-24px.svg";
import beforeSrc from "../../assets/svgs/navigate_before-24px.svg";
import lastSrc from "../../assets/svgs/last_page-24px.svg";
import firstSrc from "../../assets/svgs/first_page-24px.svg";
import { Menu } from "../menus/default";
import { InputFieldVW } from "./../inputs";
import searchSrc from "../../assets/svgs/search-24px.svg";

moment.locale("hr");
interface IProps {
  columns: Array<IColumn>;
  data: any;
  title?: string;
  rowClicked?: (data: any) => void;
  rowContextmenu?: (data: any, event: any) => void;
  dataClicked?: (data: any, row: any) => void;
  onSearch?: (searhVal: string) => void;
  momentInstance?: any;
  searchLabel?: string;
  momentDateFormat?: string;
  usePagination?: boolean;
  paginationOptions?: Array<number>;
  className?: string;
}

export const Table = ({
  columns,
  data,
  title,
  momentInstance,
  momentDateFormat = "L",
  usePagination,
  searchLabel = "Search rows",
  paginationOptions = [5, 10, 20],
  className,
  rowClicked,
  onSearch,
  dataClicked,
  rowContextmenu
}: IProps) => {
  const [pageableData, setPageableData] = useState(data);
  const [paginationOption, setPaginationOption] = useState<number>(
    paginationOptions[0]
  );
  const [pageNum, setPageNum] = useState<number>(0);
  const [openPaginationMenu, setOpenPaginationMenu] = useState<boolean>(false);
  const [searchVal, setSearchval] = useState<string>("");

  useEffect(() => {
    updateRows();
  }, [data]);
  useEffect(() => {
    onSearch && onSearch(searchVal);
  }, [searchVal]);
  useEffect(() => {
    updateRows();
  }, [pageNum]);
  useEffect(() => {
    setOpenPaginationMenu(false);
    setPageNum(0);
    updateRows();
  }, [paginationOption]);

  const totalPages = Math.ceil(data.length / paginationOption);

  function updateRows() {
    const startIndex = pageNum * paginationOption;
    const newData = data.slice(startIndex, startIndex + paginationOption);
    setPageableData(newData);
  }
  function handleNextPage() {
    const nextPage = (pageNum + 1) % totalPages;
    setPageNum(nextPage);
    setOpenPaginationMenu(false);
  }
  function handlePreviousPage() {
    const previousPage = (pageNum - 1) % totalPages;
    setPageNum(previousPage <= 0 ? 0 : previousPage);
    setOpenPaginationMenu(false);
  }
  function handleLastPage() {
    setPageNum(totalPages - 1);
    setOpenPaginationMenu(false);
  }
  function handleFirstPage() {
    setPageNum(0);
    setOpenPaginationMenu(false);
  }
  return (
    <div className={`${styles.root} ${className}`}>
      {title && (
        <Spacing pv="2xs" className={styles.title}>
          <PageTitleFont>{title}</PageTitleFont>
        </Spacing>
      )}
      {onSearch && (
        <div className={styles.search}>
          <InputFieldVW
            label={searchLabel}
            value={searchVal}
            onClear={() => setSearchval("")}
            iconSrc={searchSrc}
            onChange={e => setSearchval(e.target.value)}
          />
        </div>
      )}
      <div className={styles.table}>
        <table>
          <thead>
            {columns.map((col: IColumn, index: number) => (
              <th key={index}>
                <PageTitleFont>{col.title}</PageTitleFont>
              </th>
            ))}
          </thead>
          <tbody>
            {pageableData.map((row: any, index: number) => (
              <tr key={index} onClick={() => rowClicked && rowClicked(row)}>
                {columns.map((col: IColumn) => (
                  <td
                    data-title={col.title}
                    onContextMenu={e =>
                      rowContextmenu && rowContextmenu(row, e)
                    }
                    onClick={() =>
                      dataClicked && dataClicked(row[col.field], row)
                    }
                  >
                    {col.isCustom ? (
                      row[col.field]
                    ) : (
                      <BodyFont>
                        {col.isDate
                          ? momentInstance
                            ? momentInstance(row[col.field]).format(
                                momentDateFormat
                              )
                            : moment(row[col.field]).format(momentDateFormat)
                          : row[col.field]}
                      </BodyFont>
                    )}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {usePagination && (
          <div className={styles.tFoot}>
            <div className={styles.pageNumber}>
              <BodyFont>
                {pageNum + 1} / {totalPages}
              </BodyFont>
            </div>
            <img src={firstSrc} alt="first page" onClick={handleFirstPage} />
            <img
              src={beforeSrc}
              alt="previous page"
              onClick={handlePreviousPage}
            />
            <div className={styles.paginationOptions}>
              <div
                className={styles.paginationNumber}
                onClick={() => setOpenPaginationMenu(!openPaginationMenu)}
              >
                <BodyFont>{paginationOption}</BodyFont>
              </div>
              {openPaginationMenu && (
                <Menu
                  className={styles.paginationMenu}
                  key={paginationOption}
                  onItemClick={({ value }) =>
                    setPaginationOption(value as number)
                  }
                  items={paginationOptions.map(po => {
                    return {
                      label: po.toString(),
                      value: po
                    };
                  })}
                />
              )}
            </div>

            <img src={nextSrc} alt="next page" onClick={handleNextPage} />
            <img src={lastSrc} alt="last page" onClick={handleLastPage} />
          </div>
        )}
      </div>
    </div>
  );
};
